// === Call to action section (C2ASection) data === //

export const C2AData = {
    titleFR: "Progressez",
    subTitleFR: (
        <>
            <span className="cursiveSpan">à votre </span>rythme
        </>
    ),
    titleEN: "Improve",
    subTitleEN: (
        <>
            <span className="cursiveSpan">at your own </span>pace
        </>
    ),
    descriptionFR:
        "Des cours adaptés aux besoins de chacuns, donnés par une professeure de chant diplômée avec plus de 30 ans d’expérience vocale.",
    descriptionEN:
        "Classes tailored to individual needs, taught by Tania, a certified vocal coach with over 30 years of vocal experience.",
    buttonFR: "Réservez un cours",
    buttonEN: "Book a lesson",
};
